import type { DependencyList, EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

export function useDidUpdateEffect(effect: EffectCallback, deps?: DependencyList) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      return effect();
    }
    didMountRef.current = true;

    return () => undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
